import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RequestInviteRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const url = `https://o0bf65aidiq.typeform.com/to/vD6U85I7#src=linkedin`;
        window.location.href = url;
    }, [navigate]);

    return null;
};

export { RequestInviteRedirect };
